/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getArtist = /* GraphQL */ `
  query GetArtist($cognitoId: String!) {
    getArtist(cognitoId: $cognitoId) {
      cognitoId
      artistName
      hometown
      biography
      preferredGenres {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      follows {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          artistId
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listArtists = /* GraphQL */ `
  query ListArtists(
    $cognitoId: String
    $filter: ModelArtistFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listArtists(
      cognitoId: $cognitoId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cognitoId
        artistName
        hometown
        biography
        preferredGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        follows {
          items {
            id
            fanId
            artistId
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFan = /* GraphQL */ `
  query GetFan($cognitoId: String!) {
    getFan(cognitoId: $cognitoId) {
      cognitoId
      fullName
      favoriteGenres {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      zipCode
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
      isReturningFan
      createdAt
      updatedAt
    }
  }
`;
export const listFans = /* GraphQL */ `
  query ListFans(
    $cognitoId: String
    $filter: ModelFanFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFans(
      cognitoId: $cognitoId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSession = /* GraphQL */ `
  query GetSession($id: ID!) {
    getSession(id: $id) {
      id
      artistId
      spotifyUri
      spotifyId
      trackName
      artistName
      playCount
      genres {
        id
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        genre {
          id
          genre
          superGenre
          isSuperGenre
          fans {
            nextToken
          }
          artists {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      startDate
      endDate
      isActive
      isArchived
      archivedDate
      isDeleted
      deletedDate
      createdAt
      updatedAt
      allFeedback {
        items {
          id
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          sessionId
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          comment
          createdAt
          updatedAt
        }
        nextToken
      }
      allLikes {
        items {
          id
          likeValue
          fanId
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          sessionId
          createdAt
          updatedAt
        }
        nextToken
      }
    }
  }
`;
export const listSessions = /* GraphQL */ `
  query ListSessions(
    $id: ID
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSessions(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      sessionId
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      comment
      createdAt
      updatedAt
    }
  }
`;
export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $id: ID
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFeedbacks(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        sessionId
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        comment
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTbLike = /* GraphQL */ `
  query GetTbLike($id: ID!) {
    getTbLike(id: $id) {
      id
      likeValue
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      sessionId
      createdAt
      updatedAt
    }
  }
`;
export const listTbLikes = /* GraphQL */ `
  query ListTbLikes(
    $id: ID
    $filter: ModelTbLikeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTbLikes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        likeValue
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        sessionId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTbFollows = /* GraphQL */ `
  query GetTbFollows($id: ID!) {
    getTbFollows(id: $id) {
      id
      fanId
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      artistId
      createdAt
      updatedAt
    }
  }
`;
export const listTbFollowss = /* GraphQL */ `
  query ListTbFollowss(
    $id: ID
    $filter: ModelTbFollowsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTbFollowss(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        artistId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getGenre = /* GraphQL */ `
  query GetGenre($id: ID!) {
    getGenre(id: $id) {
      id
      genre
      superGenre
      isSuperGenre
      fans {
        items {
          id
          fan {
            cognitoId
            fullName
            zipCode
            isReturningFan
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      artists {
        items {
          id
          artist {
            cognitoId
            artistName
            hometown
            biography
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      sessions {
        items {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listGenres = /* GraphQL */ `
  query ListGenres(
    $filter: ModelGenreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGenres(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFanGenre = /* GraphQL */ `
  query GetFanGenre($id: ID!) {
    getFanGenre(id: $id) {
      id
      fan {
        cognitoId
        fullName
        favoriteGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        zipCode
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
        isReturningFan
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listFanGenres = /* GraphQL */ `
  query ListFanGenres(
    $filter: ModelFanGenreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFanGenres(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        genre {
          id
          genre
          superGenre
          isSuperGenre
          fans {
            nextToken
          }
          artists {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getArtistGenre = /* GraphQL */ `
  query GetArtistGenre($id: ID!) {
    getArtistGenre(id: $id) {
      id
      artist {
        cognitoId
        artistName
        hometown
        biography
        preferredGenres {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        follows {
          items {
            id
            fanId
            artistId
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listArtistGenres = /* GraphQL */ `
  query ListArtistGenres(
    $filter: ModelArtistGenreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArtistGenres(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        artist {
          cognitoId
          artistName
          hometown
          biography
          preferredGenres {
            nextToken
          }
          follows {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        genre {
          id
          genre
          superGenre
          isSuperGenre
          fans {
            nextToken
          }
          artists {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSessionGenre = /* GraphQL */ `
  query GetSessionGenre($id: ID!) {
    getSessionGenre(id: $id) {
      id
      session {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      genre {
        id
        genre
        superGenre
        isSuperGenre
        fans {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        artists {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        sessions {
          items {
            id
            createdAt
            updatedAt
          }
          nextToken
        }
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listSessionGenres = /* GraphQL */ `
  query ListSessionGenres(
    $filter: ModelSessionGenreFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSessionGenres(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        genre {
          id
          genre
          superGenre
          isSuperGenre
          fans {
            nextToken
          }
          artists {
            nextToken
          }
          sessions {
            nextToken
          }
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const sessionsByArtist = /* GraphQL */ `
  query SessionsByArtist(
    $artistId: String
    $sortDirection: ModelSortDirection
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sessionsByArtist(
      artistId: $artistId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const sessionSpotifyUri = /* GraphQL */ `
  query SessionSpotifyUri(
    $spotifyUri: String
    $sortDirection: ModelSortDirection
    $filter: ModelSessionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    sessionSpotifyUri(
      spotifyUri: $spotifyUri
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        artistId
        spotifyUri
        spotifyId
        trackName
        artistName
        playCount
        genres {
          id
          session {
            id
            artistId
            spotifyUri
            spotifyId
            trackName
            artistName
            playCount
            startDate
            endDate
            isActive
            isArchived
            archivedDate
            isDeleted
            deletedDate
            createdAt
            updatedAt
          }
          genre {
            id
            genre
            superGenre
            isSuperGenre
            createdAt
            updatedAt
          }
          createdAt
          updatedAt
        }
        startDate
        endDate
        isActive
        isArchived
        archivedDate
        isDeleted
        deletedDate
        createdAt
        updatedAt
        allFeedback {
          items {
            id
            fanId
            sessionId
            comment
            createdAt
            updatedAt
          }
          nextToken
        }
        allLikes {
          items {
            id
            likeValue
            fanId
            sessionId
            createdAt
            updatedAt
          }
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const feedbackBySessionAndDate = /* GraphQL */ `
  query FeedbackBySessionAndDate(
    $sessionId: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedbackBySessionAndDate(
      sessionId: $sessionId
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        sessionId
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        comment
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const feedbackByFan = /* GraphQL */ `
  query FeedbackByFan(
    $fanId: String
    $sessionId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    feedbackByFan(
      fanId: $fanId
      sessionId: $sessionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        sessionId
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        comment
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const likesByFan = /* GraphQL */ `
  query LikesByFan(
    $fanId: String
    $sortDirection: ModelSortDirection
    $filter: ModelTbLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    likesByFan(
      fanId: $fanId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        likeValue
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        sessionId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const likesBySession = /* GraphQL */ `
  query LikesBySession(
    $sessionId: ID
    $sortDirection: ModelSortDirection
    $filter: ModelTbLikeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    likesBySession(
      sessionId: $sessionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        likeValue
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        session {
          id
          artistId
          spotifyUri
          spotifyId
          trackName
          artistName
          playCount
          genres {
            id
            createdAt
            updatedAt
          }
          startDate
          endDate
          isActive
          isArchived
          archivedDate
          isDeleted
          deletedDate
          createdAt
          updatedAt
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
        }
        sessionId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const followsByFan = /* GraphQL */ `
  query FollowsByFan(
    $fanId: String
    $sortDirection: ModelSortDirection
    $filter: ModelTbFollowsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    followsByFan(
      fanId: $fanId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        artistId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const followsByArtist = /* GraphQL */ `
  query FollowsByArtist(
    $artistId: String
    $sortDirection: ModelSortDirection
    $filter: ModelTbFollowsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    followsByArtist(
      artistId: $artistId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fanId
        fan {
          cognitoId
          fullName
          favoriteGenres {
            nextToken
          }
          zipCode
          allFeedback {
            nextToken
          }
          allLikes {
            nextToken
          }
          isReturningFan
          createdAt
          updatedAt
        }
        artistId
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
